import { AgResourceLanguage } from '../types';

export const orderDetails: AgResourceLanguage['orderDetails'] = {
  pastOrdersDetails: {
    freeGiftTitle: 'Share Free Packs',
    trackOrderButton: 'Bestellung nachverfolgen',
    orderItems: 'Bestellt am',
    subscriptionNameOTP: 'Einmalig',
    pageTitle: 'Bestellnummer',
    defaultOrderStatus: 'Nicht verfügbar',
    orderInformation: {
      orderDateLabel: 'Platziert auf',
      statusLabel: 'Status',
      totalLabel: 'Gesamt',
      subscriptionNameLabel: 'Abonnement'
    }
  },
  upcomingOrderDetails: {
    manageSubscriptionButton: 'Abonnement verwalten',
    subscriptionProductsList: 'Abonnementprodukte:',
    orderInformation: {
      subscriptionNameLabel: 'Abonnement',
      orderDateLabel: 'Bestelldatum',
      statusLabel: 'Status',
      totalLabel: 'Gesamt'
    },
    changeDateButton: 'Platziert auf',
    emptyOrders: {
      buttonName: 'Produkt zur Bestellung hinzufügen',
      description: 'Entdecke die komplette Produkt- und Zubehörwelt von AG1, nur für Member.',
      title: 'Einmalige Add-Ons'
    },
    orderDefaultStatus: 'Unbezahlt',
    shipNowButton: 'Jetzt versenden',
    skipShipmentButton: 'Diese Lieferung überspringen',
    oneTimeField: {
      oneTimeProductsList: 'Einmalige Add-Ons',
      oneTimeSubtottal: 'Zwischensumme einmaliger Add-ons',
      addProducrToOrderButton: 'Produkt zur Bestellung hinzufügen'
    },
    pageTitle: 'Abonnement-Bestellung'
  },
  returnBackButton: 'Zurück zur Bestellhistorie',
  missingValue: 'Nicht Verfügbar'
};
